import React, { useState } from 'react';
import { runEventCreationTest } from '../test/testEventCreation';
import { toast } from 'sonner';

const TestEventCreation: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const runTest = async () => {
    setLoading(true);
    try {
      const testResult = await runEventCreationTest();
      setResult(testResult);
      toast.success('Test completed successfully!');
    } catch (error) {
      console.error('Test failed:', error);
      toast.error('Test failed: ' + (error instanceof Error ? error.message : 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded-lg shadow-sm">
      <h2 className="text-xl font-semibold mb-4">Event Creation Test</h2>
      
      <button
        onClick={runTest}
        disabled={loading}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-400"
      >
        {loading ? 'Running Test...' : 'Run Test'}
      </button>

      {result && (
        <div className="mt-4">
          <h3 className="font-medium">Test Results:</h3>
          <pre className="mt-2 p-4 bg-gray-100 rounded overflow-auto">
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default TestEventCreation; 